import axios from 'axios';
var API = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000',
    withCredentials: true
});
export var login = function (email, password) {
    return API.post('/auth/login', { email: email, password: password }, { withCredentials: true });
};
export var logout = function () {
    return API.post('/auth/logout', { withCredentials: true });
};
export var checkAuth = function () {
    return API.get('/auth/me', { withCredentials: true });
};
export var getProfileData = function () {
    return API.get('/auth/profile', { withCredentials: true });
};
export var subscribeNotifications = function (subscription) {
    return API.post('/notifications/subscribe', { subscription: JSON.stringify(subscription) }, { withCredentials: true });
};
export var readNotifications = function (nid) {
    return API.patch('/notifications/subscribe/' + nid, {}, { withCredentials: true });
};
